<p>{{ 'vee.meteringpoint.removeinfo' | translate }}</p>

